var D = Object.defineProperty, L = Object.defineProperties;
var k = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable;
var p = (e, o, s) => o in e ? D(e, o, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[o] = s, d = (e, o) => {
  for (var s in o || (o = {}))
    i.call(o, s) && p(e, s, o[s]);
  if (a)
    for (var s of a(o))
      m.call(o, s) && p(e, s, o[s]);
  return e;
}, u = (e, o) => L(e, k(o));
var c = (e, o) => {
  var s = {};
  for (var t in e)
    i.call(e, t) && o.indexOf(t) < 0 && (s[t] = e[t]);
  if (e != null && a)
    for (var t of a(e))
      o.indexOf(t) < 0 && m.call(e, t) && (s[t] = e[t]);
  return s;
};
import { jsxs as q, jsx as O } from "react/jsx-runtime";
import r from "../../../node_modules/prop-types/index.es.js";
import w, { useState as z } from "react";
import * as G from "./style.es.js";
import { Badge as M, BadgeBullet as V } from "./style.es.js";
import { BADGE_COLOR as b, COLOR_VARIANT as g } from "../../../constants/colorVariant.es.js";
import { Icon as Z } from "../Icon/Icon.es.js";
import { COMPONENT_SIZE as B } from "../../../constants/sizes.es.js";
const l = w.forwardRef((h, P) => {
  var n = h, {
    children: e,
    closable: o = !1,
    color: s = b.bgDefault,
    disabled: t = !1,
    error: C = !1,
    hasBullet: R = !1,
    isOpen: j = !0,
    onClose: f,
    text: y,
    rounded: T = !1,
    size: v = B.md,
    success: x = !1,
    variant: I = g.outlined
  } = n, N = c(n, [
    "children",
    "closable",
    "color",
    "disabled",
    "error",
    "hasBullet",
    "isOpen",
    "onClose",
    "text",
    "rounded",
    "size",
    "success",
    "variant"
  ]);
  const [A, E] = z(j), S = (_) => {
    f ? (_.stopPropagation(), f()) : E(!1);
  };
  return A ? /* @__PURE__ */ q(M, u(d({ closable: o, color: s, disabled: t, error: C, size: v, success: x, variant: I, ref: P, rounded: T }, N), { children: [
    R && /* @__PURE__ */ O(V, {}),
    e != null ? e : y,
    o && /* @__PURE__ */ O(Z, { name: "close", onClick: S, color: "currentColor" })
  ] })) : null;
}), $ = {
  children: r.node.isRequired,
  closable: r.bool,
  color: r.oneOf(Object.values(b)),
  disabled: r.bool,
  error: r.bool,
  hasBullet: r.bool,
  isOpen: r.bool,
  onClose: r.func,
  text: r.string,
  rounded: r.bool,
  size: r.oneOf(Object.values(B)),
  success: r.bool,
  variant: r.oneOf(Object.values(g))
};
l.S = G;
l.displayName = "Badge";
l.propTypes = $;
export {
  l as Badge,
  $ as badgePropTypes
};
//# sourceMappingURL=Badge.es.js.map
